








import Vue from 'vue'
import i18n from '@/i18n'

interface Methods {
  handleInput: (value: boolean) => void
}

interface Computed {
  containerClass: string
}

interface Props {
  value: boolean
  yesLabel?: string
  noLabel?: string
}

export default Vue.extend<{}, Methods, Computed, Props>({
  props: {
    value: {
      required: true,
    },
    yesLabel: {
      default: () => i18n.tc('common.yes'),
    },
    noLabel: {
      default: () => i18n.tc('common.no'),
    },
  },
  methods: {
    handleInput(value: boolean) {
      this.$emit('input', value)
    },
  },
  computed: {
    containerClass(): string {
      return this.value ? '-green' : '-red'
    },
  },
})
